// @ts-strict-ignore
export class TextureAreaBorderParameters {
  public borderColor: number;
  public forceDrawBorder: boolean;
  public drawOuterBorder: boolean;
}
